var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialMarketing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.402 10.346c4.535-4.461 11.89-4.461 16.425 0l17.598 17.308-15.019 14.771a2.007 2.007 0 0 1-2.812 0L7.402 26.5a11.29 11.29 0 0 1 0-16.154Z",
    fill: "#FC868B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.597 10.346a11.29 11.29 0 0 1 0 16.154L26.405 42.425a2.007 2.007 0 0 1-2.812 0L8.574 27.654l17.598-17.308c4.536-4.461 11.89-4.461 16.425 0Z",
    fill: "#FBB945"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m25 11.5 16.424 16.154-15.019 14.771a2.008 2.008 0 0 1-2.812 0L8.574 27.655 25 11.5Z",
    fill: "#F86126"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMarketing);
export default __webpack_public_path__ + "static/media/Social Marketing.a52a11ad11e0383729b48eb8c7870645.svg";
export { ForwardRef as ReactComponent };